import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import HomeMobileNavbar from "../components/HomeMobileNavbar";
import Navbar from "../components/Navbar";

const faqsData = [
  {
    id: "01",
    title: "Orders & Shipping",
    items: [
      {
        q: "When can I expect to receive my order?",
        a: `Nufab is a small studio and each piece is made to order. Depending on the volume of orders, it can take anywhere between 3-7 days for us to dispatch your order. Shipping within India usually takes another 3-7 days, so please allow 10-15 days in total for your handmade garment to reach you. We know you’re excited, and we appreciate your patience :))`,
      },
      {
        q: "Can I track my order?",
        a: "Yes! Once your order is placed, you’ll receive a confirmation email with a tracking link. Just click it and track away.",
      },
      {
        q: "What payment methods are accepted?",
        a: "We accept all popular methods of payment - UPI, Cash On Delivery, and most credit and debit cards. We’re also open to interesting trades ;) feel free to reach out!",
      },
      {
        q: "Can I change my delivery address after placing the order?",
        a: "Yes, as long as your order hasn’t already been dispatched. To change your address, simply head to the Your Orders section and update your details.",
      },
      {
        q: "Does Nufab ship internationally?",
        a: "Not yet, but soon!",
      },
    ],
  },
  {
    id: "02",
    title: "Returns & Exchanges",
    items: [
      {
        q: "Can I return my order?",
        a: (
          <>
            Yes, You can easily return your order as long as it wasn’t customised, within 7 days of receiving it. However, each Nufab piece is made especially for you, and we encourage mindful purchasing to avoid unnecessary returns. Please read our {" "}
            <Link to="/return-policy" className="underline">Return Policy</Link> and {" "}
            <Link to="/exchange-policy" className="underline">Exchange Policy</Link>. If you ever have feedback about a piece, we’d love to hear it so we can keep getting better for you!
          </>
        ),
      },
      {
        q: "Can I cancel my order?",
        a: (
          <>
            Yes, you can cancel your order within 24 hours of placing it. After that, our team will have already begun working on your piece. To cancel an order, simply head to Your Orders section in Your Account. You can also review {" "}
            <Link to="/return-policy" className="underline">Cancellations</Link> details here.
          </>
        ),
      },
      {
        q: "Can I exchange my product for a different size?",
        a: "Yes, if sizing is an issue, you can exchange your order instead of returning it. You can place an exchange request from the Your Orders section. If the size is right but the fit isn’t quite perfect, you can write to us at our support email people@nufab.studio, and we’ll be happy to customise your garment for a nominal fee. Please note that customised pieces are not eligible for return.",
      },
    ],
  },
  {
    id: "03",
    title: "Products & Sizing",
    items: [
      {
        q: "Will my piece look exactly like the photos?",
        a: "Simple answer: no. Our images are the closest and most accurate representation of our clothes, but because each piece is hand-stitched and made from hand-dyed fabric, no two pieces are ever exactly alike. What you receive will be one of a kind, but you can trust our photographs to never be misleading.",
      },
      {
        q: "Are all Nufab pieces handmade?",
        a: "Yes. Every single piece is stitched by hand, ethically with hand-dyed fabric. We are firmly anti-sweatshop and believe in paying our craftspeople fairly for their skill and time.",
      },
      {
        q: "How do I know my size?",
        a: (
          <>
            Our sizes loosely follow the general sizing pattern. For more precision, you can refer to the exact {" "}
            <Link to="/store" className="underline">size chart</Link> in the product section.
          </>
        ),
      },
      {
        q: "Does Nufab offer customisation?",
        a: "Yes, we provide simple customisations free of cost! You can simply opt to do so using the customise button before adding to cart. That is one of the wonderful things about made-to-order clothes (apart from the obvious ecological benefits).However, customised pieces are tailored specifically to you, hence we are unable to accept returns on them.",
      },
    ],
  },
  {
    id: "04",
    title: "Care & Materials",
    items: [
      {
        q: "Are Nufab clothes safe to machine wash?",
        a: "Many pieces use natural dyes such as Indigo that are known to bleed the first few times. While the clothes ARE machine washable, hand washing will keep them looking alive and well. In any case, we insist that you handwash them for at least the first couple of times to avoid any mishaps.",
      },
      {
        q: "Do Nufab pieces shrink after washing?",
        a: "We wash and dry all our fabrics prior to stitching in order to avoid any changes in the piece on washing. That being said, you should expect your piece to fade or shrink a little after many washes, as with all natural fabrics.",
      },
      {
        q: "Does Nufab use premium materials?",
        a: "At Nufab, we believe culture and craft shouldn’t be an elitist commodity that comes with a hefty price tag. In order to keep our clothes accessible to everyone, we avoid using “luxury” fabrics. What we do use are natural, breathable and durable fabrics, tested for quality and comfort.",
      },
      {
        q: "Are Nufab dyes safe for skin?",
        a: "Yes! At Nufab, we only use fabrics dyed with AZO-free dyes that are safe for your skin.",
      },
      {
        q: "Where does Nufab get its fabric?",
        a: "All our fabrics are sourced from small and medium textile producers and dyers in Jaipur, holding proper certifications for AZO-free dying. We do our best to buy from places with transparent and humane working conditions. As we grow, we’re excited to begin printing and dyeing our own fabrics directly with craftspeople, so we can pay them more fairly for their skill and time.",
      },
    ],
  },
  {
    id: "05",
    title: "About Nufab",
    items: [
      {
        q: "Is Nufab a sustainable brand?",
        a: "We try. All our fabrics are 100% cotton in order to have the least possible impact on the earth. We work with fabrics dyed in small workshops by Indian craftspeople, and our pieces are stitched by local masters paid well. We make each piece to-order to minimize wastage, and we use our scraps to make cool things. Sustainability is a nuanced concept we strive towards, and if you have any suggestions, we would love to hear from you!",
      },
      {
        q: "Is Nufab a design studio or clothing brand?",
        a: "Nufab began as a movement to choose our own culture for the everyday. It is a studio first, rooted in this ideology, and clothing happens to be our first project. We see this project continuing for a long time, but Nufab has no fixed bounds. In the future, we give the freedom to move into furniture, accessories, or any other space where it can bring value and meaning.",
      },
      {
        q: "How can I get in touch with Nufab?",
        a: (
          <>
            The best way to reach us is via our support email (people@nufab.info). You can also get in touch via Instagram (@nufab.studio) or Whatsapp (+91 92445 01941). For legal and data details, please review our {" "}
            <Link to="/terms-of-service" className="underline">Terms of Service</Link> and {" "}
            <Link to="/privacy-policy" className="underline">Privacy Policy</Link>. We will do our best to get in touch within one weekday, but please allow us 2-5 days to respond.
          </>
        ),
      },
    ],
  },
];

const FaqsPage = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [windowWidth, setWindowWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  React.useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const toggle = (key) => {
    setOpenIndex(openIndex === key ? null : key);
  };

  return (
    <div>
      {windowWidth < 1168 ? <HomeMobileNavbar /> : <Navbar />}
    <div className="w-full max-w-full mx-auto px-4 md:px-6 py-10 md:py-20 font-[bdogrotesk] text-black">
      <p className="text-black text-lg font-medium mb-6 md:mb-0">FAQs</p>
      {faqsData.map((section, sectionIdx) => (
        <div
          key={section.id}
          // RESPONSIVE: Stack vertically on mobile, horizontal on desktop
          className="flex flex-col lg:flex-row gap-6 lg:gap-10 border-b border-black pt-10 pb-4 md:pb-10 lg:pb-0"
        >
          {/* Left column (ID) */}
          <div className="text-base font-medium text-black tracking-wide w-full lg:w-20 flex-shrink-0">
            {section.id}
          </div>

          {/* Right column Wrapper */}
          <div className="flex-1 flex flex-col gap-8 lg:grid lg:grid-cols-[minmax(260px,1fr)_minmax(560px,1.2fr)] lg:items-start lg:gap-10">
            
            {/* Title */}
            {/* RESPONSIVE: Scale font size (text-3xl -> text-6xl) and width */}
            <h2 className="w-full max-w-[420px] text-3xl md:text-5xl lg:text-6xl font-medium break-words lg:justify-self-center">
              {section.title}
            </h2>

            {/* Questions List */}
            <div className="space-y-4 w-full">
              {section.items.map((item, itemIdx) => {
                const key = `${sectionIdx}-${itemIdx}`;
                const isOpen = openIndex === key;
                const isLast = itemIdx === section.items.length - 1;

                return (
                  <div
                    key={key}
                    className={`${!isLast ? "border-b border-black" : ""} ${isLast ? "pb-0 md:pb-4" : "pb-4"}`}
                  >
                    <button
                      onClick={() => toggle(key)}
                      className="w-full flex justify-between items-start text-left group"
                    >
                      <span className={`text-sm md:text-base text-black pr-6 leading-relaxed ${isOpen ? "font-bold" : "font-medium"}`}>
                        {item.q}
                      </span>
                      <span className="text-lg leading-none flex-shrink-0 transition-transform duration-300">
                        {isOpen ? "×" : "+"}
                      </span>
                    </button>

                    <div
                      className={`overflow-hidden transition-all duration-300 ease-in-out ${
                        isOpen ? "max-h-[500px] opacity-100 mt-4" : "max-h-0 opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="text-sm md:text-base leading-relaxed pr-10 text-gray-800">
                          {item.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};

export default FaqsPage;